const RECIPIENTS_TYPES = {
  to: 'TO',
  cc: 'CC',
  bcc: 'BCC',
} as const;

export default RECIPIENTS_TYPES;
